import { useMemo } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  initialFiatPointsBalance,
  initialPointsBalance,
  getFiatPointsBalance,
  getPointsBalance,
  useGetAccountsRewardsQuery,
  usePointsBalance,
} from "@hsbc/rewards";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const PointsBalanceModalContent = () => {
  const { t, formatNumber, formatFiatCurrency, formatRewardsCurrency, brand } =
    useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PointsBalanceModalContent");
  const rewardsPoints = useGetAccountsRewardsQuery(undefined, {
    selectFromResult: ({ data }) =>
      getPointsBalance(data) || initialPointsBalance,
  });
  const rewardsFiatPoints = useGetAccountsRewardsQuery(undefined, {
    selectFromResult: ({ data }) =>
      getFiatPointsBalance(data) || initialFiatPointsBalance,
  });

  const { conversionMultiplier } = usePointsBalance();

  const oneDollarInPoints = useMemo(
    () =>
      conversionMultiplier !== undefined
        ? Math.round(1 / conversionMultiplier)
        : 0,
    [conversionMultiplier]
  );

  const formattedPoints = formatRewardsCurrency({
    value: oneDollarInPoints,
    currency: "points",
  });

  const formattedOneCurrency = formatFiatCurrency(
    {
      value: 1,
      currencyCode: brand.currency.code,
      currencySymbol: brand.currency.symbol ?? "",
    },
    { maximumFractionDigits: 0, minimumFractionDigits: 0 }
  );

  return (
    <div className={clsx(block)}>
      <div className={cn("available-points-title")}>
        {t("rewardsPointsModal.availablePoints")}
      </div>
      <div className={cn("points-balance")}>
        <span>{`${formatNumber(rewardsPoints.value)} =`}</span>
        <span className={cn("fiat-points-balance")}>
          {rewardsFiatPoints.currencyCode}
        </span>
        <span>{formatNumber(rewardsFiatPoints.value)}</span>
      </div>
      <div className={cn("points-description")}>
        {t("rewardsPointsModal.disclaimer", {
          points: formattedPoints,
          currency: formattedOneCurrency,
        })}
      </div>
    </div>
  );
};
